import newHire from './new-hire.json'
import violations from './violations.json'
import trainings from './trainings.json'

export const documentationWorkflows = [
  {
    id: 'workflow-new-hire',
    title: 'New Hire',
    type: 'workflow',
    workflow: newHire,
    description: 'See how a new hire moves from invitation through required documents, onboarding or orientation, training, and ongoing staff records.',
    cta: 'View New Hire Workflow'
  },
  {
    id: 'workflow-violations',
    title: 'Violations',
    type: 'workflow',
    workflow: violations,
    description: 'See how ePeople handles shift violations through approval requests, corrections, payroll decisions, and disciplinary follow-up.',
    cta: 'View Violations Workflow'
  },
  {
    id: 'workflow-trainings',
    title: 'Training',
    type: 'workflow',
    workflow: trainings,
    description: 'See how trainings are created, assigned, completed, reviewed, paid, renewed, and reported.',
    cta: 'View Training Workflow'
  }
]
